import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import {
  deleteDataList,
  getData,
  patchData,
  postData,
} from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";

import { PRD2050_R01Dto, PRD2050_R01LotDto } from "./Dto_PRD2050_R01";
import { PRD2050_R01Filter } from "./Store_PRD2050_R01";

const baseUrl = `${config.apiUrl}/PRD2050_R01`;

/** 화면 검색조건을 백엔드 조회 API의 요청 파라미터 형식으로 변환한다. */
const getPRD2050_R01Params = (filter: Partial<PRD2050_R01Filter>) => ({
  compCd: filter.compCd,
  workplaceCd: filter.workplaceCd,
  jobTeam: filter.jobTeam,
  startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
  endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
});

/** 검색조건에 맞는 작업지시 목록을 조회한다. */
export const getPRD2050_R01List = (
  option: string,
  filter: Partial<PRD2050_R01Filter>,
) =>
  getData<ResponseDto<PRD2050_R01Dto[]>>(`${baseUrl}/${option}`, {
    params: getPRD2050_R01Params(filter),
  });

/** 선택한 작업지시에 이미 등록된 투입 자재 LOT 목록을 조회한다. */
export const getPRD2050_R01DetailList = (productOrderNo: string) =>
  getData<ResponseDto<PRD2050_R01LotDto[]>>(
    `${baseUrl}/detail/${productOrderNo}`,
  );

/** 작업지시 품목의 BOM을 기준으로 투입 가능한 재고 LOT 목록을 조회한다. */
export const getPRD2050_R01LotList = (productOrderNo: string) =>
  getData<ResponseDto<PRD2050_R01LotDto[]>>(`${baseUrl}/lot`, {
    params: { productOrderNo },
  });

/** 새로 담은 투입 자재 LOT을 등록한다. */
export const postPRD2050_R01 = (
  data: PRD2050_R01LotDto[],
) =>
  postData<PRD2050_R01LotDto[], ResponseDto<PRD2050_R01LotDto[]>>(
    `${baseUrl}/detail`,
    data,
  );

/** 기존 투입 자재 LOT의 수정 가능한 항목을 저장한다. */
export const patchPRD2050_R01 = (
  data: PRD2050_R01LotDto[],
) =>
  patchData<PRD2050_R01LotDto[], ResponseDto<PRD2050_R01LotDto[]>>(
    `${baseUrl}/detail`,
    data,
  );

/** 삭제 대상으로 지정한 투입 자재 LOT을 삭제한다. */
export const deletePRD2050_R01 = (data: PRD2050_R01LotDto[]) =>
  deleteDataList<PRD2050_R01LotDto[], ResponseDto<void>>(
    `${baseUrl}/detail`,
    data,
  );
